export var EIframeMessageTypes;
(function (EIframeMessageTypes) {
    EIframeMessageTypes["SUBMIT"] = "submit";
    EIframeMessageTypes["TRACK"] = "track";
    EIframeMessageTypes["CANCEL"] = "cancel";
})(EIframeMessageTypes || (EIframeMessageTypes = {}));
